// Textarea primitive — same tonal style as TextInput (design/v3/SettingsPage.jsx:196-205).

import type { CSSProperties, TextareaHTMLAttributes } from 'react';

export interface TextareaProps
  extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  disabled?: boolean;
  error?: boolean;
  style?: CSSProperties;
}

export function Textarea({
  value,
  onChange,
  placeholder,
  rows = 3,
  disabled,
  error,
  style,
  ...rest
}: TextareaProps) {
  const borderColor = error ? 'var(--danger)' : 'var(--border-base)';
  return (
    <textarea
      {...rest}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      disabled={disabled}
      style={{
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        padding: 'var(--control-pad-y) var(--control-pad-x)',
        fontSize: 13,
        fontFamily: 'var(--font-sans)',
        lineHeight: 'var(--lh-body)',
        color: 'var(--fg-1)',
        background: disabled ? 'var(--bg-subtle)' : 'var(--bg-surface)',
        border: `1px solid ${borderColor}`,
        borderRadius: 'var(--radius-sm)',
        outline: 'none',
        resize: 'vertical',
        transition: 'border-color var(--dur-fast) var(--ease-out)',
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? 'not-allowed' : 'text',
        ...style,
      }}
    />
  );
}
